import React, { useState } from "react";
import "../UIcss/Spinners.css";
import { spinnerData } from "./spinnerData.js";
import CodeViewer from "./CodeViewer.jsx";
import {
  FaReact,
  FaSpinner,
  FaCircleNotch,
  FaSync,
  FaCog,
  FaSnowflake,
  FaSun,
  FaStar,
} from "react-icons/fa";

// Array of icons to use for spinners that need inner content
const icons = [
  FaReact,
  FaSpinner,
  FaCircleNotch,
  FaSync,
  FaCog,
  FaSnowflake,
  FaSun,
  FaStar,
];

const Spinners = () => {
  const [viewerState, setViewerState] = useState({
    isOpen: false,
    name: "",
    jsx: "",
    css: "",
  });

  const openViewer = (spinner) => {
    setViewerState({
      isOpen: true,
      name: `Spinner ${spinner.id}`,
      jsx: spinner.html,
      css: spinner.css,
    });
  };

  const closeViewer = () => {
    setViewerState({ ...viewerState, isOpen: false });
  };

  return (
    <>
      <div className="spinners-container">
        <div className="library-header">
          <div className="header-content">
            <h1>
              <FaSpinner /> Spinners <span>Library</span>
            </h1>
          </div>
        </div>

        <div className="spinners-grid">
          {spinnerData.map((spinner) => {
            // Select a random icon based on id to keep it consistent
            const IconComponent = icons[spinner.id % icons.length];

            return (
              <div
                key={spinner.id}
                className="spinner-item"
                onClick={() => openViewer(spinner)}
              >
                <div className="spinner-visual-area">
                  <div className={spinner.className}>
                    {/* Most spinners in the CSS seem to rely on the class itself, 
                      but some might expect content. We'll add an icon just in case 
                      the CSS expects it (like .spinner-1 svg) */}
                    <IconComponent />
                  </div>
                </div>
                <span className="spinner-label">Spinner {spinner.id}</span>
              </div>
            );
          })}
        </div>

        <CodeViewer
          isOpen={viewerState.isOpen}
          onClose={closeViewer}
          componentName={viewerState.name}
          jsxCode={viewerState.jsx}
          cssCode={viewerState.css}
        />
      </div>
    </>
  );
};

export default Spinners;
